module.exports = __webpack_public_path__ + "static/stars-4e5fc9a5cd8584a9b75000b466c96f9b.png";